var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRating = function SvgRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 49,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 48,
    y: 0.467,
    fillOpacity: 0.5,
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB81C",
    d: "M18.896 17.933 24 11.313l5.104 6.62 7.992 2.684-5.046 7.145.204 7.963L24 33.421l-8.254 2.304.204-7.992-5.017-7.116zM51.896 17.933 57 11.313l5.104 6.62 7.992 2.684-5.046 7.145.204 7.963L57 33.421l-8.254 2.304.204-7.992-5.017-7.116zM84.896 17.933 90 11.313l5.104 6.62 7.992 2.684-5.046 7.145.204 7.963L90 33.421l-8.254 2.304.204-7.992-5.017-7.116zM117.896 17.933l5.104-6.62 5.104 6.62 7.992 2.684-5.046 7.145.204 7.963L123 33.421l-8.254 2.304.204-7.992-5.017-7.116zM150.896 17.933l5.104-6.62 5.104 6.62 7.992 2.684-5.046 7.145.204 7.963L156 33.421l-8.254 2.304.204-7.992-5.017-7.116z"
  })));
};
export default SvgRating;